import { type JSX } from "react";

import { useVoss } from "../state/VossProvider";
import { Drawer } from "./Drawer";

/**
 * Debug drawer — hidden unless Debug Mode is enabled in Settings. Reveals the Brain's own turn
 * telemetry (intent, plan, context, gateway outcome, verification). It surfaces capability-level
 * facts only — never a provider name.
 */
export function DebugDrawer({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element {
  const { debugLog } = useVoss();
  return (
    <Drawer open={open} title="Debug" onClose={onClose}>
      <p className="voss-field__desc">Live orchestration for the last turn. Providers are never shown — only capabilities, policy, and verification.</p>
      {debugLog.length === 0 ? (
        <p className="voss-empty">Send a message with Debug Mode on to see orchestration here.</p>
      ) : (
        debugLog.map((entry, i) => (
          <div key={`${entry.stage}-${i}`}>
            <div className="voss-section-label" style={{ padding: 0 }}>
              {entry.stage}
            </div>
            <div className="voss-debug-line">{JSON.stringify(entry.detail, null, 2)}</div>
          </div>
        ))
      )}
    </Drawer>
  );
}
